/**
 * Các options khi chọn tại combobox Tổng hợp của form tham số báo cáo
 * nvthinh 15.07.2024
 * đổi vị trí cho đúng thứ tự
 * htthoa 24.7.2024
 */
export default {
  AllProvince: 2,
  Province: 1,
  District: 0,
};
